import { X } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"

type Props = {
  phone: any | null
  onClose: () => void
}

export default function PhoneDetailsModal({ phone, onClose }: Props) {
  if (!phone) return null

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-2xl w-full max-w-lg p-6 space-y-5"
          initial={{ scale: 0.9, y: 40 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.9, y: 40 }}
        >
          {/* Header */}
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold">
              Détails du téléphone
            </h2>
            <button onClick={onClose}>
              <X />
            </button>
          </div>

          {/* Infos */}
          <div className="grid grid-cols-2 gap-4 text-sm">
            <Info label="Modèle" value={phone.modelId.name} />
            <Info label="IMEI" value={phone.imei} />
            <Info label="Prix d’achat" value={`${phone.buyPrice?.toLocaleString()} FCFA`} />
            <Info label="Statut" value={phone.status === "IN_STOCK" ? "En stock" : "Vendu"} />

            {phone.status === "SOLD" && (
              <>
                <Info label="Prix de vente" value={`${phone.sellPrice?.toLocaleString()} FCFA`} />
                <Info label="Client" value={phone.clientName} />
                <Info label="Téléphone client" value={phone.clientPhone} />
                <Info label="Payé" value={`${phone.paid?.toLocaleString()} FCFA`} />
                <Info label="Reste" value={`${phone.remaining?.toLocaleString()} FCFA`} />
                <Info label="Date vente" value={phone.soldAt} />
              </>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}

function Info({ label, value }: { label: string; value?: string }) {
  return (
    <div>
      <p className="text-gray-500 text-xs">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  )
}
